import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginpageComponent } from './loginpage.component';
import { LoginComponent } from 'src/app/components/login/login.component';
import { SessionStateGuard } from 'src/app/domain/session-state.guard';
import { LoginAppComponent } from '../../components/login-app/login-app.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginpageComponent, canActivate: [SessionStateGuard],
    children: [
      { path: '', component: LoginComponent }
    ]
  },
  { path: 'login/AISP/:id', component: LoginpageComponent, canActivate: [SessionStateGuard],
    children: [
      { path: '', component: LoginComponent }
    ]
  },
  { path: 'login/PISP/:id', component: LoginpageComponent, canActivate: [SessionStateGuard],
    children: [
      { path: '', component: LoginComponent }
    ]
  },
  { path: 'empresas/login/AISP/:id', component: LoginpageComponent, canActivate: [SessionStateGuard],
    children: [
      { path: '', component: LoginComponent }
    ]
  },
  { path: 'empresas/login/PISP/:id', component: LoginpageComponent, canActivate: [SessionStateGuard],
    children: [
      { path: '', component: LoginComponent }
    ]
  },
  { path: 'app/:id', component: LoginpageComponent, canActivate: [SessionStateGuard],
    children: [
      { path: '', component: LoginAppComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginPageRoutingModule {}

